// NBL1_Player Pages
import rules from "../../Data/Rules"
import functions from "../../Data/Functions"
import Verification from "../Steps/Verification"
import Base_Details from "../Steps/BaseDetails"

let step1, step2, Associations, Program, displayMessage, DOB
let Divisions = ['Club', 'Representative', 'Other', 'Prefer Not to Say']

const PortalAgeCheck = p => v => {
    let Start = functions.FormatDate(v.Age_Start, 'YYYY-MM-DD')
    let End = functions.FormatDate(v.Age_End, 'YYYY-MM-DD')
    // console.log(Start, End, DOB)
    if (DOB < Start || DOB > End) {
        return `Your Age must be between ${functions.FormatDate(Start, 'DD-MM-YYYY')} to ${functions.FormatDate(End, 'DD-MM-YYYY')} to qualify for this Program`
    }
    return true
}


// IPP Player Step Schema
const Load_IPP_Steps = () => {
    return {
        Portal: '2024 IPP Player',
        MainColor: "#f5924c",
        Logo: require(`../../assets/IPP.png`),
        Title: `<h2>Indigenous Pathways 2024 Registration Form</h2>`,
        Description: `The Basketball Queensland Indigenous Pathways Program (BQIPP) aims to increase Aboriginal and Torres Strait Islander peoples basketball participation by engaging, promoting, and delivering a range of culturally inclusive sport and physical activities throughout Queensland.`,
        Model: {},
        steps: [
            // Step 1
            step1,
            // Step 2
            step2,
            // Step 3
            {
                stepno: 3,
                title: 'Rego',
                valid: true,
                information: `<h4 style="text-align:center;">${displayMessage}</h4>`,
                Schema: {
                    association: {
                        type: 'select',
                        label: 'Association',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Association is Required')],
                        class: 'mx-1 px-1',
                        items: Associations,
                        returnObject: true,
                        itemText: 'Detail',
                        value: '',
                    },
                    division: {
                        type: 'select',
                        label: 'Division Played',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Division Played is Required')],
                        class: 'mx-1 px-1',
                        items: Divisions,
                        value: '',
                        OUG: { Contact_Details: { Type: 759, Action: "Unique" } }
                    },
                    team: {
                        type: 'select',
                        label: 'Choose Program',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Program is Required'), PortalAgeCheck()],
                        class: 'mx-1 px-1',
                        items: Program,
                        returnObject: true,
                        itemText: 'Detail',
                        // col: 12,
                        value: '',
                        Role: 1,
                        onInput: (ev, portal) => { },
                        OUG: { Contact_Roles: true, Type: "Teams" }
                    }
                },
                PreStep: (thisStep, portal) => {
                    DOB = functions.FormatDate(portal.Model.DOB, 'YYYY-MM-DD')
                },
            },
            // Step 4
            {
                stepno: 4,
                title: 'Submit',
                valid: true,
                information: `<h2 style="text-align:center;color:red">Important: <br>Please press Submit to Finalise your registration</h2>`,
                Schema: {},
                PostStep: (thisStep, portal) => {
                    functions.sendEmail(
                        {
                            User_Name: 'Indigenous Pathways Program',
                            User_Email: 'simon.taylor@basketballqld.net.au',
                            emailstosend: portal.Model.email,
                            Subject: `${portal.Model.team.Detail} Booking Confirmed`,
                            Message: `${portal.Model.team.Terms}`
                        }
                    )
                },
            },
            // Step 5
            {
                stepno: 5,
                title: 'Finish',
                valid: true,
                information: `Thank you for your submitted registration for the 2024 Indigenous Pathways Program.</br></br>
                We have sent you a confirmation email and a receipt of your payment.</br></br>
                If you have any queries regarding the program or your registration please contact <a href="mailto:simon.taylor@basketballqld.net.au">simon.taylor@basketballqld.net.au</a>`,
                Schema: {},
            }
        ]
    }
}



export default {

    LoadSchema: async (Parameters) => {
        step1 = await Verification.LoadSchema(1)
        step2 = await Base_Details.LoadSchema(2)
        // Countries = await functions.GetCountries()
        Associations = await functions.GetCodeBy({ Type: "Associations", Organisation: 292 }, true);
        // Program = await functions.GetCodeBy({ Type: "Teams", Code_id: 3875 }, true);
        Program = await functions.getData(`SELECT
                                            Codes.*, Products.*,
                                            (SELECT Messages FROM Codes_Messages WHERE Code_id = 3875 AND Type = 'Trials') AS Information
                                        FROM
                                            Codes
                                            INNER JOIN
                                            Products
                                            ON
                                                Codes.Code_id = Products.Team_id
                                        WHERE
                                            Codes.Code_id = 3875 AND
                                            Products.Status = 700`, false);

        displayMessage = Program[0].Information
        return Load_IPP_Steps()
    },



}

